<template>
  <div style="margin-top: 60px; background-color: aqua">
    <h2>这是另一页</h2>
    <router-link to="/">
      <button>回到首页</button>
    </router-link>
  </div>
</template>

<style scoped></style>
